import { SolarModel } from 'src/Libs/solar/models/solar.model'
import { SolarOverviewDto } from 'src/Libs/solar/dto/solar-overview.dto'

const fromDtoToModelTransformer = (dto: SolarOverviewDto): SolarModel => {
  return { ...dto }
}

export default fromDtoToModelTransformer
